import './styles.scss'

import React from 'react'
import { useActions, useValues } from 'kea'
import { useSelector } from 'react-redux'

import railsContext from 'lib/selectors/rails-context'
import I18n from 'lib/i18n'

import courseLogic from '~/scenes/course/show/logic'

const Translate = () => {
  const { translateCourseAndProfile } = useActions(courseLogic)
  const { course, translating } = useValues(courseLogic)
  const { i18nLocale } = useSelector(railsContext)

  const { locale, profileLocale, profileManualLocales, defaultLocale, manualLocales, availableLocales } = course

  const profileToBeTranslated = !profileManualLocales.includes(i18nLocale)
  const courseToBeTranslated = !manualLocales.includes(i18nLocale)
  const profileToBeTranslatedOrCourseToBeTranslated = profileToBeTranslated || courseToBeTranslated

  const isTranslatedProfile = profileToBeTranslated && profileLocale === i18nLocale
  const isCourseTranslated = courseToBeTranslated && locale === i18nLocale

  const isTranslated = isTranslatedProfile || isCourseTranslated

  const handleTranslate = () => {
    translateCourseAndProfile(locale === i18nLocale ? defaultLocale : i18nLocale)
  }

  if (availableLocales && availableLocales.length < 2) {
    return null
  }

  if (availableLocales.indexOf(i18nLocale) < 0) {
    return null
  }

  if (!profileToBeTranslatedOrCourseToBeTranslated) {
    return null
  }

  return (
    <div className='translate-container'>
      <span className='translate-text'>
        {isTranslated ? I18n.t('courses.show.translated') : I18n.t('courses.show.translate_texts')}
        <span
          className='translate-button'
          onClick={handleTranslate}
          style={{ cursor: translating ? 'wait' : 'pointer' }}
        >
          {isTranslated ? I18n.t('courses.show.see_original') : I18n.t('courses.show.click_to_translate')}
        </span>
      </span>
    </div>
  )
}

export default Translate
